import { Action } from '@ngrx/store';

export class AdvisorAction implements Action {

    public static getAdvisor = '[Advisor] get_advisor';
    public static getAdvisorError = '[Advisor] get_advisor_error';
    public static getAdvisorSuccess = '[Advisor] get_advisor_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
